/**
 * Header Module
 * @description 헤더 관련 클라이언트 스크립트 통합 모듈
 */

import { initHeaderOverlay } from './overlay';
import { initSideMenu } from './side-menu';

/**
 * 헤더 전체 초기화
 * - 오버레이 (겹치기/고정) 처리
 * - 사이드 메뉴 (카테고리/햄버거) 처리
 */
export const initHeader = (): void => {
  initHeaderOverlay();
  initSideMenu();
};
